import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  showBack?: boolean;
  breadcrumbData?: Array<{
    label: string;
    path?: string;
  }>;
}

/**
 * Title and breadcrumb are intentionally not rendered — pages carry their
 * own heading via CardHeader instead. Kept as a component (rather than
 * removed from every page) solely so the `showBack` button keeps working
 * on pages that rely on it for back-navigation.
 */
const PageHeader: React.FC<PageHeaderProps> = ({ showBack = false }) => {
  const navigate = useNavigate();

  if (!showBack) return null;

  return (
    <button
      onClick={() => navigate(-1)}
      className="px-2 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-200 rounded flex items-center text-sm dark:text-gray-400 dark:hover:text-gray-100 dark:hover:bg-gray-700"
      aria-label="Back"
    >
      <ArrowLeft size={16} />
    </button>
  );
};

export default PageHeader;
